import { format, formatDistanceToNowStrict, isPast } from 'date-fns'

export function formatDate(iso: string): string {
  return format(new Date(iso), 'd MMM yyyy')
}

export function formatDateTime(iso: string): string {
  return format(new Date(iso), 'd MMM yyyy, HH:mm')
}

export function formatTime(iso: string): string {
  return format(new Date(iso), 'HH:mm')
}

/** "4 minutes ago" / "in 3 hours" */
export function relativeTime(iso: string): string {
  const distance = formatDistanceToNowStrict(new Date(iso))
  return isPast(new Date(iso)) ? `${distance} ago` : `in ${distance}`
}

export function formatCurrency(amount: number): string {
  return amount % 1 === 0 ? `$${amount}` : `$${amount.toFixed(2)}`
}

export function formatAvailability(value: number): string {
  return `${value.toFixed(2)}%`
}

export function formatDuration(minutes: number | null): string {
  if (minutes === null) {
    return 'Ongoing'
  }
  if (minutes < 60) {
    return `${minutes} min`
  }
  const hours = Math.floor(minutes / 60)
  const remainder = minutes % 60
  return remainder === 0 ? `${hours} hr` : `${hours} hr ${remainder} min`
}

export function formatInterval(minutes: number): string {
  if (minutes === 1) {
    return 'Every minute'
  }
  if (minutes < 60) {
    return `Every ${minutes} minutes`
  }
  const hours = minutes / 60
  return hours === 1 ? 'Every hour' : `Every ${hours} hours`
}
